import * as React from 'react';
import { session } from './app/Session';
import { Provider } from 'mobx-react';
import SoftPhone from './SoftPhone';
import { callStore } from './app/calls/CallStore';
import { notifications } from './app/notifications/NotificationStore';
import { sipStore } from './app/services/sip/SipStore';
import { softphoneStore } from './app/softphone/SoftphoneStore';
import { voiceLogStore } from './app/calls/voiceLogStore';

class SoftPhoneWithProviders extends React.Component<{ widget?: boolean; }, {}> {
    public render(): React.ReactNode {
        const { widget } = this.props;

        return (
            <Provider
                session={session}
                callStore={callStore}
                notifications={notifications}
                voiceLogStore={voiceLogStore}
                sipStore={sipStore}
                softphoneStore={softphoneStore}
            >
                <SoftPhone widget={widget} />
            </Provider>
        );
    }
}

export default SoftPhoneWithProviders;
